import {Injectable} from '@angular/core';
import {HttpRequestService } from '../../shared/services/http-request.service';
import 'rxjs/add/operator/map';
import {environment} from '../../../environments/environment';
import {GridService} from '../../shared/services/grid.service';
import {VenueDatabaseAnalyticsModel} from 'app/venues/venue-database/venue-database.model';

@Injectable()
export class VenueDatabaseService extends GridService {
  private getVenuesURL = environment.apiUrl + '/VenueCms/GetVenues';
  private getFilterEnumsURL = environment.apiUrl + '/VenueCms/GetVenueListFilterEnums';
  private getVenuesLocations = environment.apiUrl + '/VenueCms/GetVenuesLocations';
  private getVenueDatabaseAnalyticsUrl = environment.apiUrl + '/VenueCms/GetVenueDatabaseAnalytics';

  constructor(private _http: HttpRequestService) {
    super();
    this.getData = this.getVenues;
  }
  getFilterEnums() {
    return this._http.get(this.getFilterEnumsURL);
  }
  getVenues(data) {
    return this._http.post(this.getVenuesURL, data);
  }

  getAllVenuesLocations(request) {
    return this._http.post(this.getVenuesLocations, request);
  }

  getVenueDatabaseAnalytics(model: VenueDatabaseAnalyticsModel) {
    return this._http.post(this.getVenueDatabaseAnalyticsUrl, model);
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/venues/venue-database/venue-database.service.ts